import React from 'react';
import ReactDOM from 'react-dom';

import App from './components/App';

import './custom.scss';
import './styles.css';

ReactDOM.render(<App />, document.querySelector('#root'));
